import { lazy } from 'react';

const RETRY_STORAGE_PREFIX = 'lazy-retry:';

const isChunkLoadFailure = (error) => {
  const message = error?.message || '';
  const name = error?.name || '';

  return (
    name === 'ChunkLoadError' ||
    message.includes('ChunkLoadError') ||
    message.includes('Loading chunk') ||
    message.includes('Loading CSS chunk')
  );
};

const buildRetryKey = (key) => `${RETRY_STORAGE_PREFIX}${key}`;

const shouldReloadForChunkError = (key) => {
  try {
    return window.sessionStorage.getItem(buildRetryKey(key)) !== 'true';
  } catch (error) {
    return true;
  }
};

const markChunkReloadAttempt = (key) => {
  try {
    window.sessionStorage.setItem(buildRetryKey(key), 'true');
  } catch (error) {
    void error;
  }
};

const clearChunkReloadAttempt = (key) => {
  try {
    window.sessionStorage.removeItem(buildRetryKey(key));
  } catch (error) {
    void error;
  }
};

export const lazyWithRetry = (importer, key) =>
  lazy(async () => {
    try {
      const component = await importer();
      clearChunkReloadAttempt(key);
      return component;
    } catch (error) {
      if (
        typeof window !== 'undefined' &&
        isChunkLoadFailure(error) &&
        shouldReloadForChunkError(key)
      ) {
        markChunkReloadAttempt(key);
        window.location.reload();
        return new Promise(() => {});
      }

      clearChunkReloadAttempt(key);
      throw error;
    }
  });

export default lazyWithRetry;
